import agent from "../api/agent";

export interface OutletUser {
  id: number;
  is_active:boolean,
  outlet_id:number,
  org_id:number,
  user:{
    id:number,
    name:string,
    email:string,
    mobile:string
  },
  org: {
    id: number;
    name: string;
    legalname:string
  },
  outlet:{
    name:string,
  };
  created_at: string;
  
}


export const fetchOutletUser = async (): Promise<any> => {
  const response = await agent.OutletUser.getUser();
  return response;
};

export const addOutletUser = async (data: any): Promise<any> => {
  const response = await agent.OutletUser.createuser(data);
  return response;
};

export const fetchUserRole = async (data: any): Promise<any> => {
  const response = await agent.User.getUserRole();
  return response;
};

export const getUserById = async (id: number): Promise<any> => {
  return await agent.OutletUser.getById(id);
};

export const updateUser = async (data: any, id: number): Promise<any> => {
  return await agent.OutletUser.updateUser(data, id);
};

